import { createTheme } from "@mui/material/styles";
import { styleOverrides } from "./shared";


export const lightTheme = createTheme({
    typography: {
        fontFamily: `"Roboto", sans-serif`
    },
    palette: {
        secondary: {
            main: "#e1e2e3",
            dark: "#e0e0e0",
            light: "#dedede"
        },
        info: {
            main: "#007bff"
        },
        background: {
            default: "#FFFFFF",
            paper: "#FFFFFF"
        },
        text: {
            primary: '#000000',
            secondary: "#474747"
        },
        custom: {
            border: "black"
        }
    },
    ...styleOverrides
  });

  lightTheme.glow = ""